import { TextField, TextViewFieldConfig } from '@indigohive/cogfy-types'
import { FieldConfigurationsProps } from '..'
import { Toggle } from '../../../components'
import { useActiveViewId, useSelectedFieldToUpdate, useViewFields } from '../../../lib'
import { t } from 'i18next'

export function TextConfigurations (props: FieldConfigurationsProps) {
  const { state, controller } = props

  const viewFields = useViewFields(state)
  const activeViewId = useActiveViewId(state)
  const selectedField = useSelectedFieldToUpdate(state) as TextField

  const viewField = viewFields?.find(viewField => viewField.fieldId === selectedField?.id && viewField.viewId === activeViewId)
  const viewFieldConfig = viewField?.config as TextViewFieldConfig

  return (
    <Toggle
      color="primary"
      label={t('editFieldDrawer:Format content')}
      onChange={({ target }) => {
        if (!viewField) return
        controller.onUpdateViewFieldConfig(viewField.id, { text: { textFormat: target.checked } })
      }}
      checked={Boolean(viewFieldConfig?.text?.textFormat)}
    />
  )
}
